import { PageLayout } from "@/components/layout/PageLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    id: "geo-seo-2026",
    title: "GEO SEO – De ce trebuie combinate în 2026 pentru vizibilitate reală",
    description: "Ce este GEO SEO și de ce trebuie combinate SEO tradițional și Generative Engine Optimization în 2026 pentru vizibilitate în Google și AI?",
    category: "GEO SEO",
    date: "10 Feb 2026",
    readTime: "12 min",
  },
  {
    id: "generative-engine-optimization",
    title: "Generative Engine Optimization (GEO) – Ce Este și De Ce Devine Esențial în 2026",
    description: "Ce este Generative Engine Optimization (GEO)? Află cum optimizezi site-ul pentru ChatGPT, Gemini, Perplexity și AI Overview în 2026.",
    category: "GEO",
    date: "9 Feb 2026",
    readTime: "14 min",
  },
  {
    id: "optimizare-chatgpt-gemini-perplexity",
    title: "Optimizare pentru ChatGPT / Gemini / Perplexity în 2026 – Ghid complet",
    description: "Cum optimizezi site-ul pentru ChatGPT, Gemini și Perplexity în 2026? Află ce înseamnă GEO și cum crești vizibilitatea în AI.",
    category: "Optimizare AI",
    date: "8 Feb 2026",
    readTime: "15 min",
  },
  {
    id: "cum-apare-brandul-in-ai",
    title: "Cum apare brandul în AI? (Ghid complet 2026)",
    description: "Cum apare brandul tău în ChatGPT, Gemini și AI Overview? Află ce influențează percepția AI și cum îți optimizezi brandul pentru vizibilitate în 2026.",
    category: "Branding AI",
    date: "7 Feb 2026",
    readTime: "14 min",
  },
  {
    id: "de-ce-nu-recomanda-chatgpt",
    title: "De ce nu recomandă ChatGPT site-ul meu? (Ghid complet 2025)",
    description: "ChatGPT nu recomandă site-ul tău? Află cauzele reale și cum optimizezi pentru vizibilitate în AI prin Generative Engine Optimization (GEO).",
    category: "ChatGPT",
    date: "6 Feb 2026",
    readTime: "13 min",
  },
  {
    id: "cum-apare-in-chatgpt",
    title: "Cum apare în ChatGPT? Ghid complet pentru vizibilitate în AI (2025)",
    description: "Cum apare un site în ChatGPT? Află cum funcționează recomandările AI, ce influențează vizibilitatea și cum îți optimizezi site-ul pentru motoarele generative.",
    category: "ChatGPT",
    date: "5 Feb 2026",
    readTime: "14 min",
  },
  {
    id: "ai-overview-google",
    title: "AI Overview Google – Cum funcționează și cum apari acolo în 2026",
    description: "Ce este AI Overview Google și cum apari în el? Află cum funcționează, ce influențează selecția surselor și cum îți optimizezi site-ul pentru 2026.",
    category: "AI Overview",
    date: "4 Feb 2026",
    readTime: "15 min",
  },
  {
    id: "optimizare-seo-romania",
    title: "Optimizare SEO România – Ce Funcționează în 2025 (Ghid Complet Actualizat)",
    description: "Optimizare SEO în România în 2025: strategii actuale care funcționează în Google și în AI Overview. Ghid complet pentru trafic, autoritate și vizibilitate reală.",
    category: "SEO România",
    date: "3 Feb 2026",
    readTime: "16 min",
  },
  {
    id: "de-ce-nu-apare-site-in-google",
    title: "De ce nu apare site-ul în Google? (Ghid complet 2025)",
    description: "Site-ul tău nu apare în Google? Află cele mai frecvente cauze, cum verifici problema și ce trebuie să faci pentru a obține vizibilitate reală în 2025.",
    category: "SEO Tehnic",
    date: "2 Feb 2026",
    readTime: "15 min",
  },
  {
    id: "magazin-online-seo",
    title: "Magazin Online SEO – Ghid Complet pentru eCommerce în 2025",
    description: "SEO pentru magazin online în 2025: optimizare tehnică, structură categorie, pagini produs, backlink-uri și AI Overview. Ghid complet pentru creșterea vânzărilor.",
    category: "eCommerce SEO",
    date: "1 Feb 2026",
    readTime: "17 min",
  },
  {
    id: "seo-ieftin",
    title: "SEO ieftin – Este o soluție reală sau pierdere de bani?",
    description: "SEO ieftin merită sau te costă mai mult pe termen lung? Află diferența dintre SEO low-cost, SEO real și optimizarea automatizată în 2025.",
    category: "SEO Strategie",
    date: "31 Ian 2026",
    readTime: "12 min",
  },
  {
    id: "cum-sa-optimizez-site-ul",
    title: "Cum să optimizez site-ul – Ghid practic complet pentru 2025",
    description: "Cum să optimizezi site-ul pentru Google și AI în 2025? Ghid practic pas cu pas: SEO tehnic, conținut, backlink-uri și GEO.",
    category: "SEO Ghid",
    date: "30 Ian 2026",
    readTime: "14 min",
  },
];

const Blog = () => {
  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-foreground mb-4">Blog OptiRO.ai</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Articole, ghiduri și studii de caz despre SEO, GEO și optimizarea pentru motoarele AI.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.id}`}>
              <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden h-full">
                <CardHeader>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground mb-2">
                    <Badge variant="secondary">{post.category}</Badge>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground mb-2">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {post.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock className="w-4 h-4" />
                      {post.readTime}
                    </span>
                  </div>
                  <CardTitle className="group-hover:text-primary transition-colors line-clamp-2 text-lg">
                    {post.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="line-clamp-3 mb-4">
                    {post.description}
                  </CardDescription>
                  <span className="inline-flex items-center text-primary font-medium text-sm">
                    Citește mai mult
                    <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                  </span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground">
            Mai multe articole vor fi publicate în curând. Abonează-te pentru notificări!
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

export default Blog;
